/* HOMEPAGE ONLY: Sends Year, Make and Model selections to the complete finder page. */
(function () {
  'use strict';

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function addOption(select, value, label) {
    var option = document.createElement('option');
    option.value = value;
    option.textContent = label || value;
    select.appendChild(option);
  }

  function availableForYear(product, year) {
    if (!year) return true;
    return product.yearMin && product.yearMax && year >= product.yearMin && year <= product.yearMax;
  }

  function init(root, catalog) {
    var products = catalog.products || [];
    var vehicleProducts = products.filter(function (product) {
      return product.category !== 'apparel' && product.category !== 'gift_card';
    });
    var form = root.querySelector('[data-vdi-home-form]');
    var yearSelect = root.querySelector('[data-vdi-home-year]');
    var makeSelect = root.querySelector('[data-vdi-home-make]');
    var modelSelect = root.querySelector('[data-vdi-home-model]');
    if (!form || !yearSelect || !makeSelect || !modelSelect) return;

    var years = vehicleProducts.reduce(function (values, product) {
      if (!product.yearMin || !product.yearMax || product.yearMax - product.yearMin > 80) return values;
      for (var year = product.yearMin; year <= product.yearMax; year += 1) values.add(year);
      return values;
    }, new Set());

    Array.from(years).sort(function (a, b) { return b - a; }).forEach(function (year) {
      addOption(yearSelect, String(year), String(year));
    });

    function populateMakes(preferredMake) {
      var selectedYear = yearSelect.value ? Number(yearSelect.value) : null;
      var makes = uniqueSorted(vehicleProducts.filter(function (product) {
        return availableForYear(product, selectedYear);
      }).map(function (product) { return product.make; }));

      makeSelect.innerHTML = '';
      addOption(makeSelect, '', 'Select make');
      makes.forEach(function (make) { addOption(makeSelect, make, make); });
      makeSelect.value = preferredMake && makes.indexOf(preferredMake) !== -1 ? preferredMake : '';
    }

    function populateModels(preferredModel) {
      var selectedYear = yearSelect.value ? Number(yearSelect.value) : null;
      var selectedMake = makeSelect.value;
      modelSelect.innerHTML = '';
      addOption(modelSelect, '', 'Select model');

      if (!selectedMake) {
        modelSelect.disabled = true;
        return;
      }

      var models = uniqueSorted(vehicleProducts.filter(function (product) {
        return product.make === selectedMake && availableForYear(product, selectedYear);
      }).map(function (product) { return product.model; }));

      models.forEach(function (model) { addOption(modelSelect, model, model); });
      modelSelect.disabled = models.length === 0;
      modelSelect.value = preferredModel && models.indexOf(preferredModel) !== -1 ? preferredModel : '';
    }

    yearSelect.addEventListener('change', function () {
      var make = makeSelect.value;
      var model = modelSelect.value;
      populateMakes(make);
      populateModels(model);
    });

    makeSelect.addEventListener('change', function () {
      populateModels('');
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var params = new URLSearchParams();
      params.set('view', 'find-your-vehicle');
      if (yearSelect.value) params.set('year', yearSelect.value);
      if (makeSelect.value) params.set('make', makeSelect.value);
      if (modelSelect.value) params.set('model', modelSelect.value);
      var destination = root.getAttribute('data-results-url') || '/pages/find-your-vehicle';
      window.location.assign(destination + (params.toString() ? '?' + params.toString() : ''));
    });

    populateMakes('');
    populateModels('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var catalog = window.VDI_VEHICLE_CATALOG;
    if (!catalog || !Array.isArray(catalog.products)) return;
    document.querySelectorAll('[data-vdi-home-finder]').forEach(function (root) {
      init(root, catalog);
    });
  });
}());
